<template>
    <b-modal id="rescheduleJobModal" centered modal-class="modal-garden-help modal-confirm-message">
        <div class="d-block ">
            <input id="job_id" name="job_id" type="hidden" v-model="job_id" />
            <input id="client" name="client" type="hidden" v-model="client_name" />
            <!-- <img src="@/assets/images/garden-help/close-circle.png" class="close-img" />
        <h4 class="title-confirm-modal ">Cancel Job</h4>-->
            <h4 class="title-confirm-modal "> Please select a new date</h4>
            <!-- <p class="message-confirm-modal text-center my-3 ">
                Please select a new date
            </p> -->
            <b-row class="justify-content-center"> <b-col xl="8" lg=10 md="11">
                    <b-form-group class="form-group-garden-help form-group-datetime-garden-help mb-0 pb-0" label=""
                        label-for="new_booking_date" label-class="form-label-garden-help">
                        <p class="error_validation_message_p_gardenhelp" v-if="invalid_booking_date">
                            Please select date
                        </p>
                        <date-picker v-model="new_booking_date" type="datetime" 
                            value-type="YYYY-MM-DD HH:mm"
                            format="DD MMM YYYY, hh:mm a" :partial-update="true" :confirm="true"
                            :disabled-date="notBeforeToday" :disabled-time="notBeforeTodayTime"
                            popup-class="datetime-picker-garden-help"
                            input-class="form-control form-control-garden-help w-100" required :append-to-body="false">
                            <template v-slot:icon-calendar>
                                <img src="@/assets/images/garden-help/calendar-icon-input.png" />
                            </template>
                        </date-picker>

                    </b-form-group>
                </b-col></b-row>
        </div>

        <template class="justify-content-center mt-5" #modal-footer>
            <b-row class="justify-content-center w-100 m-0">
                <b-col xl="4" lg="5" md="6" class="text-center">
                    <b-button type="button" variant="garden-help-primary" class="btn-bumblebee btn-garden-help mb-1 w-100"
                        v-if="!is_loading" @click="clickSave">
                        Submit
                    </b-button>
                    <b-button type="button" disabled variant="garden-help-primary"
                        class="btn-bumblebee btn-garden-help  mb-1 w-100" v-else>
                        <b-spinner small label="Small Spinner" variant="light"></b-spinner>
                        Loading
                    </b-button>
                </b-col>
                <b-col xl="4" lg="5" md="6" class="text-center">
                    <b-button type="button" variant="garden-help-danger-outline"
                        class="btn-bumblebee btn-garden-help mb-1 w-100" @click="closeModalCancel">
                        Cancel
                    </b-button>
                </b-col>


            </b-row>
        </template>
    </b-modal>
</template>
<script>
import $ from "jquery";
import axios from "axios";
import moment from 'moment'

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
    name: "RescheduleJob",
    components: { DatePicker },
    props: ["client_name", "job_id", "booking_date"],
    data() {
        return {
            is_loading: false,
            new_booking_date: null,
            invalid_booking_date: false
        };
    },

    mounted() {
        console.log(this.booking_date)
        this.new_booking_date = moment(this.booking_date).format("YYYY-MM-DD HH:mm")
    },

    methods: {
        notBeforeToday(date) {
            return date < new Date(new Date().setHours(0, 0, 0, 0));
        },
        notBeforeTodayTime(date) {
            let h = new Date().getHours()
            return date < new Date(new Date().setHours(h + 2, 0, 0, 0));
        },
        notAfterToday(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            return date > new Date(today.getTime() - 1 * 24 * 3600 * 1000);
            // return date > new Date()
        },
        clickSave() {
            console.log("in confirm cancel job ", this.client_name, this.job_id, this.new_booking_date);

            if (this.new_booking_date == null || this.new_booking_date == '') {
                this.invalid_booking_date = true
            } else {
                this.invalid_booking_date = false
                this.is_loading = true;

                // this.$bvModal.hide("rescheduleJobModal");
                let requestData = {
                    client: this.client_name,
                    "order_details": {
                        "booking_date": this.new_booking_date
                    },
                }
                axios
                    .post(
                        "/jobs/job-action/" + this.job_id,
                        requestData,
                        {
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                                client: this.client_name,
                                Authorization:
                                    "Bearer " +
                                    JSON.parse(window.localStorage.getItem("user")).access_token,
                            },
                        }
                    )
                    .then((response) => {
                        console.log(response);
                        this.is_loading = false;
                        this.$fire({
                            text: response.data.success,
                            type: "success",
                            customClass: {
                                container: "swal-alert-garden-help",
                                confirmButton:
                                    "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                                cancelButton:
                                    "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                            },

                        }).then((r) => {
                            this.$bvModal.hide("rescheduleJobModal");
                            this.$parent.getJobDetails()
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                        this.is_loading = false;

                        this.$fire({
                            // title: "Title",
                            text: error.response.data.error,
                            type: "error",
                            customClass: {
                                container: "swal-alert-garden-help",
                                confirmButton:
                                    "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                                cancelButton:
                                    "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                            },
                            // timer: 5000,
                        }).then((r) => {
                        });

                    });

            }




            return;

        },
        closeModalCancel() {
            this.$bvModal.hide("rescheduleJobModal");
        },
    },
};
</script>
      


// WEBPACK FOOTER //
// src/projects/garden_help/jobs/modal_actions/RescheduleJob.vue